
import { WorldCountry } from '../types';
import { turkeyExpanded2 } from './turkeyExpansion2';

export const turkeyExpansion3: WorldCountry[] = [
  turkeyExpanded2
];
